import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import { jsPDF } from 'jspdf';
import { useLocation } from 'react-router-dom';
import skillService from '../services/skillService';
import departmentService from '../services/departmentService';
import { API_ENDPOINTS } from '../config/api';
import API_BASE_URL from '../config/api';
import AdminProfile from '../components/Admin/AdminProfile';
import AdminViewPlans from '../components/Admin/AdminViewPlans';
import AdminDataDownload from '../components/Admin/AdminDataDownload';
import ViewAssets from '../components/ViewAssets';
import SupplierDetails from './SupplierDetails';
import UserApprovals from './UserApprovals';
import UserListings from './UserListings';
import ImportFiles from './ImportFiles';
import '../styles/LabAdminDashboard.css';
import {
  FaTachometerAlt, 
  FaUserPlus,
  FaUserClock,
  FaCheckCircle,
  
  FaUsers,
  FaCogs,
  FaChartBar,
  FaClipboard,
  FaClock,
  FaSync,
  FaEdit,
  FaTrash,
  FaBuilding,
  FaFolderPlus,
  FaEllipsisV,
  FaUser,
  FaCreditCard,
  FaDownload,
  FaEye,
  FaWarehouse,
  FaTruck,
  FaBars,
  FaTimes
} from "react-icons/fa";
import {
  PieChart,
  Pie,
  BarChart,
  Bar,
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  Cell
} from 'recharts';

const LabAdminDashboard = ({ user }) => {
  const location = useLocation();
  const [activeSection, setActiveSection] = useState('dashboard');
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  const [pendingUsers, setPendingUsers] = useState([]);
  const [approvedUsers, setApprovedUsers] = useState([]);

  const [loading, setLoading] = useState(true);
  const [refreshing, setRefreshing] = useState(false);
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [approvalStats, setApprovalStats] = useState({
    pendingRequests: 0,
    totalTechnicians: 0,
    totalAssistants: 0,
    totalDepartments: 0,
 
    pendingAssetUserRequests: 0,
    approvedAssetUsers: 0
  });

  const [issueStats, setIssueStats] = useState({
    totalIssues: 0,
    resolved: 0,
    pending: 0,
    inProgress: 0,
    rejected: 0,
    closed: 0
  });

  // Form states
  const [addTechnicianForm, setAddTechnicianForm] = useState({
    firstName: '',
    lastName: '',
    email: '',
    password: '',
    confirmPassword: '',
    skills: []
  });

  const [addAssistantForm, setAddAssistantForm] = useState({
    firstName: '',
    lastName: '',
    email: '',
    password: '',
    confirmPassword: ''
  });

  const [addAssetUserForm, setAddAssetUserForm] = useState({
    firstName: '',
    lastName: '',
    email: '',
    password: '',
    confirmPassword: ''
  });




  const [skillsOptions, setSkillsOptions] = useState([]);
  const [newSkillName, setNewSkillName] = useState('');

  // Asset categories state
  const [categories, setCategories] = useState([]);
  const [newCategoryName, setNewCategoryName] = useState('');
  const [editingCategoryId, setEditingCategoryId] = useState(null);
  const [editedCategoryName, setEditedCategoryName] = useState('');

  // SubCategories state
  const [selectedCategoryId, setSelectedCategoryId] = useState('');
  const [subCategories, setSubCategories] = useState([]);
  const [newSubCategoryName, setNewSubCategoryName] = useState('');
  const [editingSubCategoryId, setEditingSubCategoryId] = useState(null);
  const [editedSubCategoryName, setEditedSubCategoryName] = useState('');

  // Specifications state
  const [selectedSubCategoryId, setSelectedSubCategoryId] = useState('');
  const [specifications, setSpecifications] = useState([]);
  const [newSpecificationName, setNewSpecificationName] = useState('');
  const [editingSpecificationId, setEditingSpecificationId] = useState(null);
  const [editedSpecificationName, setEditedSpecificationName] = useState('');

  // Skills state
  const [editingSkillId, setEditingSkillId] = useState(null);
  const [editedSkillName, setEditedSkillName] = useState('');

  // Departments state
  const [departments, setDepartments] = useState([]);
  const [newDeptLabel, setNewDeptLabel] = useState('');
  const [assignDeptForm, setAssignDeptForm] = useState({
    departmentId: '',
    assetInchargeId: ''
  });
  const [editingDeptId, setEditingDeptId] = useState(null);
  const [editedDeptName, setEditedDeptName] = useState('');

  // Approved asset users state
  const [assetUsers, setAssetUsers] = useState([]);
  const [invoices, setInvoices] = useState([]);
  const [invoicesLoading, setInvoicesLoading] = useState(false);
  const [viewingInvoice, setViewingInvoice] = useState(null);
  const [planLimitPopup, setPlanLimitPopup] = useState({
    visible: false,
    title: '',
    message: '',
    limitType: 'users'
  });
  const [popupPlans, setPopupPlans] = useState([]);
  const [popupPlansLoading, setPopupPlansLoading] = useState(false);

  const openPlanLimitPopup = (title, message, limitType = 'users') => {
    setPlanLimitPopup({
      visible: true,
      title,
      message,
      limitType
    });
  };

  const closePlanLimitPopup = () => {
    setPlanLimitPopup((prev) => ({ ...prev, visible: false }));
  };

  const fetchPopupPlanOptions = async () => {
    try {
      setPopupPlansLoading(true);
      const token = sessionStorage.getItem('token');
      const headers = { Authorization: `Bearer ${token}` };

      const [plansRes, companyRes] = await Promise.all([
        axios.get(API_ENDPOINTS.PLANS, { headers }),
        axios.get(`${API_BASE_URL}/api/companies/user/company`, { headers })
      ]);

      const plans = Array.isArray(plansRes.data) ? plansRes.data : [];
      const company = companyRes.data?.company || companyRes.data || {};
      const currentPlanId = String(company?.planId?._id || company?.planId || '').trim();
      const currentPlanName = String(company?.planId?.name || company?.plan || '').trim().toLowerCase();

      const filteredPlans = plans.filter((plan) => {
        const byId = currentPlanId && String(plan?._id || '').trim() === currentPlanId;
        const byName = currentPlanName && String(plan?.name || '').trim().toLowerCase() === currentPlanName;
        return !byId && !byName;
      });

      setPopupPlans(filteredPlans);
    } catch (err) {
      setPopupPlans([]);
    } finally {
      setPopupPlansLoading(false);
    }
  };

  const isPlanActionError = (payload = {}) => {
    const msg = String(payload?.message || '').toLowerCase();
    return Boolean(payload?.limitExceeded || payload?.expired) || /limit|plan|subscription|renew|upgrade/.test(msg);
  };

  useEffect(() => {
    //const loggedInUser = JSON.parse(sessionStorage.getItem('user'));
  
    fetchPendingUsers();
    fetchApprovedUsers();

    fetchIssuesStats();
    fetchSkills();
    fetchCategories();
    fetchDepartments();
    fetchAssetUserRequests();
    fetchApprovedAssetUsers();
    fetchInvoices();
    updateDepartmentsCount();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const section = new URLSearchParams(location.search).get('section');
    if (section) {
      setActiveSection(section);
    }
  }, [location.search]);

  useEffect(() => {
    if (planLimitPopup.visible) {
      fetchPopupPlanOptions();
    }
  }, [planLimitPopup.visible]);

  const fetchInvoices = async () => {
    try {
      setInvoicesLoading(true);
      const token = sessionStorage.getItem('token');
      const response = await axios.get(API_ENDPOINTS.LAB_ADMIN_INVOICES, {
        headers: { Authorization: `Bearer ${token}` }
      });
      const data = response.data?.data || (Array.isArray(response.data) ? response.data : []);
      setInvoices(data);
    } catch (err) {
      console.error('Error fetching invoices:', err);
      setInvoices([]);
    } finally {
      setInvoicesLoading(false);
    }
  };

  const formatDate = (value) => {
    if (!value) return '-';
    const d = new Date(value);
    if (Number.isNaN(d.getTime())) return '-';
    return d.toLocaleDateString();
  };

  const calculateDueDate = (purchasedOn, billingCycle) => {
    if (!purchasedOn) return null;
    const purchased = new Date(purchasedOn);
    if (Number.isNaN(purchased.getTime())) return null;
    const dueDate = new Date(purchased);
    const normalizedCycle = String(billingCycle || '').toLowerCase().trim();
    
    if (normalizedCycle === 'monthly') {
      dueDate.setMonth(dueDate.getMonth() + 1);
    } else if (normalizedCycle === 'quarterly') {
      dueDate.setMonth(dueDate.getMonth() + 3);
    } else if (normalizedCycle === 'yearly' || normalizedCycle === 'annual') {
      dueDate.setFullYear(dueDate.getFullYear() + 1);
    } else {
      // Default to 30 days if not specified
      dueDate.setDate(dueDate.getDate() + 30);
    }
    
    return dueDate;
  };

  const generateInvoicePDF = (invoice, shouldSave = true) => {
    const doc = new jsPDF({ unit: 'pt', format: 'a4' });
    const pageWidth = doc.internal.pageSize.getWidth();
    const sideMargin = 40;
    const topMargin = 40;
    const contentWidth = pageWidth - sideMargin * 2;
    const currency = 'INR';

    const formatAmount = (value) => {
      const amount = Number(value || 0);
      return `${currency} ${amount.toFixed(2)}`;
    };

    const safeText = (value) => String(value ?? '-');

    const customerName = invoice.customer?.companyName || invoice.customer?.contactPerson || '-';
    const customerAddressLines = [
      invoice.customer?.contactPerson ? `Contact: ${invoice.customer.contactPerson}` : null,
      invoice.customer?.email ? `Email: ${invoice.customer.email}` : null,
      invoice.customer?.phone ? `Phone: ${invoice.customer.phone}` : null
    ].filter(Boolean);

    const invoiceNumber = safeText(invoice.invoiceNumber || 'INV-000001');
    const invoiceDate = formatDate(invoice.purchasedOn);
    const calculatedDueDate = calculateDueDate(invoice.purchasedOn, invoice.billingCycle);
    const dueDate = calculatedDueDate ? formatDate(calculatedDueDate) : formatDate(invoice.expiryDate);
    const billingCycle = safeText((invoice.billingCycle || '-').toUpperCase());
    const qty = 1;
    const rate = Number(invoice.amount || 0);
    const subTotal = rate * qty;
    const taxRate = Number(invoice.taxRate || 0);
    const taxAmount = (subTotal * taxRate) / 100;
    const totalAmount = subTotal + taxAmount;

    let currentY = topMargin;

    // Header Section - Company Name + INVOICE Title
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(20);
    doc.setTextColor(30, 30, 30);
    doc.text('AssetFlows', sideMargin, currentY);
    
    doc.setFont('helvetica');
    doc.setFontSize(11);
    doc.setTextColor(80, 80, 80);
    currentY += 24;
    doc.text('AssetFlows Technologies Pvt. Ltd.', sideMargin, currentY);
    currentY += 14;
    doc.text('Innovation Park, Pune, Maharashtra 411014', sideMargin, currentY);
    currentY += 14;
    doc.text('Email: billing@assetflow.in | Website: www.assetflow.in', sideMargin, currentY);
    
    // INVOICE Title on right
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(28);
    doc.setTextColor(25, 74, 160);
    doc.text('INVOICE', sideMargin + contentWidth, currentY - 38, { align: 'right' });

    currentY += 28;
    doc.setDrawColor(200, 200, 200);
    doc.line(sideMargin, currentY, sideMargin + contentWidth, currentY);
    currentY += 16;

    // Invoice Details Row (Invoice #, Date, Due Date, etc.)
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(10);
    doc.setTextColor(80, 80, 80);
    
    const col1 = sideMargin;
    const col2 = sideMargin + contentWidth * 0.25;
    const col3 = sideMargin + contentWidth * 0.5;
    const col4 = sideMargin + contentWidth * 0.75;

    // Labels
    doc.text('Invoice No.', col1, currentY);
    doc.text('Issue Date', col2, currentY);
    doc.text('Due Date', col3, currentY);
    doc.text('Billing Cycle', col4, currentY);
    
    currentY += 14;
    
    // Values
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(11);
    doc.setTextColor(30, 30, 30);
    doc.text(invoiceNumber, col1, currentY);
    doc.text(invoiceDate, col2, currentY);
    doc.text(dueDate, col3, currentY);
    doc.text(billingCycle, col4, currentY);

    currentY += 20;
    doc.setDrawColor(200, 200, 200);
    doc.line(sideMargin, currentY, sideMargin + contentWidth, currentY);
    currentY += 16;

    // Bill To Section
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(11);
    doc.setTextColor(30, 30, 30);
    doc.text('BILL TO', sideMargin, currentY);
    
    currentY += 16;
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(12);
    doc.text(customerName, sideMargin, currentY);
    
    currentY += 14;
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(10);
    doc.setTextColor(80, 80, 80);
    customerAddressLines.forEach((line) => {
      doc.text(line, sideMargin, currentY);
      currentY += 12;
    });

    currentY += 8;

    // Additional Details Row
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(10);
    doc.text('Status:', sideMargin, currentY);
    doc.text(safeText(invoice.status || 'ongoing').toUpperCase(), sideMargin + 40, currentY);
    
    doc.text('Payment Gateway:', col2, currentY);
    doc.text(safeText(invoice.paymentGateway || 'N/A'), col2 + 110, currentY);

    currentY += 20;
    doc.setDrawColor(200, 200, 200);
    doc.line(sideMargin, currentY, sideMargin + contentWidth, currentY);
    currentY += 14;

    // Items Table Header
    doc.setFillColor(25, 74, 160);
    doc.rect(sideMargin, currentY, contentWidth, 20, 'F');
    
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(10);
    doc.setTextColor(255, 255, 255);
    
    const tableCol1 = sideMargin + 10;
    const tableCol3 = sideMargin + contentWidth - 150;
    const tableCol4 = sideMargin + contentWidth - 100;
    const tableCol5 = sideMargin + contentWidth - 40;

    doc.text('Description', tableCol1, currentY + 13);
    doc.text('Quantity', tableCol3, currentY + 13);
    doc.text('Unit Price', tableCol4, currentY + 13, { align: 'right' });
    doc.text('Amount', tableCol5, currentY + 13, { align: 'right' });

    currentY += 24;

    // Items Table Row
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(10);
    doc.setTextColor(30, 30, 30);
    doc.setDrawColor(220, 220, 220);
    doc.rect(sideMargin, currentY, contentWidth, 32);

    doc.text(safeText(invoice.planName || 'Subscription Plan'), tableCol1, currentY + 12);
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(9);
    doc.setTextColor(100, 100, 100);
    doc.text(
      `Plan access from ${invoiceDate} | Limits: ${safeText(invoice.limits?.users ?? '-')} users, ${safeText(invoice.limits?.assets ?? '-')} assets`,
      tableCol1,
      currentY + 24
    );

    doc.setFont('helvetica', 'normal');
    doc.setFontSize(10);
    doc.setTextColor(30, 30, 30);
    doc.text(String(qty), tableCol3, currentY + 12, { align: 'center' });
    doc.text(formatAmount(rate), tableCol4, currentY + 12, { align: 'right' });
    doc.text(formatAmount(subTotal), tableCol5, currentY + 12, { align: 'right' });

    currentY += 36;
    doc.setDrawColor(200, 200, 200);
    doc.line(sideMargin, currentY, sideMargin + contentWidth, currentY);
    currentY += 14;

    // Totals Section (Right aligned)
    const totalsX = sideMargin + contentWidth - 160;
    const totalsLabelX = totalsX;
    const totalsValueX = sideMargin + contentWidth;

    doc.setFont('helvetica', 'normal');
    doc.setFontSize(10);
    doc.setTextColor(80, 80, 80);
    
    doc.text('Subtotal', totalsLabelX, currentY);
    doc.setFont('helvetica', 'bold');
    doc.text(formatAmount(subTotal), totalsValueX, currentY, { align: 'right' });

    currentY += 14;
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(10);
    doc.setTextColor(80, 80, 80);
    doc.text(`Tax (${taxRate.toFixed(2)}%)`, totalsLabelX, currentY);
    doc.setFont('helvetica', 'bold');
    doc.text(formatAmount(taxAmount), totalsValueX, currentY, { align: 'right' });

    currentY += 16;
    doc.setDrawColor(200, 200, 200);
    doc.line(totalsLabelX, currentY, totalsValueX, currentY);
    currentY += 14;

    // Total Due
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(12);
    doc.setTextColor(25, 74, 160);
    doc.text('Total Paid', totalsLabelX, currentY);
    doc.text(formatAmount(totalAmount), totalsValueX, currentY, { align: 'right' });

    currentY += 28;
    doc.setDrawColor(200, 200, 200);
    doc.line(sideMargin, currentY, sideMargin + contentWidth, currentY);
    currentY += 14;

    // Footer
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(9);
    doc.setTextColor(100, 100, 100);
    doc.text('Thank you for choosing AssetFlows.', sideMargin, currentY);
    
    currentY += 12;
    doc.text('For billing support, contact: billing@assetflow.in', sideMargin, currentY);

    if (shouldSave) {
      doc.save(`${invoice.invoiceNumber || 'invoice'}.pdf`);
    }

    return doc;
  };

  const handleDownloadInvoice = (invoice) => {
    generateInvoicePDF(invoice, true);
  };

  const handleViewInvoice = (invoice) => {
    const doc = generateInvoicePDF(invoice, false);
    const pdfDataUrl = doc.output('dataurlstring');
    setViewingInvoice({ ...invoice, pdfDataUrl });
  };

  const fetchPendingUsers = async () => {
    try {
      setLoading(true);
      setError('');
      const token = sessionStorage.getItem('token');
      
     
      
      const response = await axios.get(API_ENDPOINTS.LAB_ADMIN_PENDING_USERS, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      
      
      const data = Array.isArray(response.data) ? response.data : 
                   (response.data?.data ? response.data.data : []);
      
      
      setPendingUsers(data);
      
      // Update approval stats with pending requests count
      setApprovalStats(prev => ({
        ...prev,
        pendingRequests: data.length
      }));
      
      setLoading(false);
    } catch (error) {
     
   
      console.error('Error status:', error.response?.status);
      setError(error.response?.data?.message || 'Failed to fetch pending users');
      
      // Initialize with empty stats on error
      setApprovalStats(prev => ({
        ...prev,
        pendingRequests: 0
      }));
      
      setLoading(false);
    }
  };

  const fetchApprovedUsers = async () => {
    try {
      const token = sessionStorage.getItem('token');
      if (!token) {
        return;
      }

     
      
      const response = await axios.get(API_ENDPOINTS.LAB_ADMIN_APPROVED_USERS, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      
      
      const data = Array.isArray(response.data) ? response.data : 
                   (response.data?.data ? response.data.data : []);
      
      const approvedTechs = data.filter(u => u.role === 'asset_technician').length;
      const approvedAssists = data.filter(u => u.role === 'asset_incharge').length;
      
   
      
      setApprovedUsers(data);
      setApprovalStats(prev => ({
        ...prev,
        totalTechnicians: approvedTechs,
        totalAssistants: approvedAssists
      }));
    } catch (error) {
    
    
      console.error('Error status:', error.response?.status);
      console.error('Error message:', error.message);
      // Initialize with default empty stats
      setApprovalStats(prev => ({
        ...prev,
        totalTechnicians: 0,
        totalAssistants: 0
      }));
    }
  };



  const fetchIssuesStats = async () => {
    try {
      const token = sessionStorage.getItem('token');
      
      if (!token) {
        
        return;
      }
  
      const response = await axios.get(API_ENDPOINTS.ISSUES, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      
      
      
      const issues = Array.isArray(response.data) ? response.data : 
                     (response.data?.data ? response.data.data : []);
      
    
      
      // Calculate issue statistics
      const resolved = issues.filter(i => i.status === 'resolved').length;
      const pending = issues.filter(i => i.status === 'pending').length;
      const inProgress = issues.filter(i => i.status === 'in_progress').length;
      const rejected = issues.filter(i => i.status === 'rejected').length;
      const closed = issues.filter(i => i.status === 'closed').length;
      
      const stats = {
        totalIssues: issues.length,
        resolved: resolved,
        pending: pending,
        inProgress: inProgress,
        rejected: rejected,
        closed: closed
      };
      
     
      
      setIssueStats(stats);
    } catch (error) {
      console.error('Error fetching issues stats:', error);
   
      // Initialize with default empty stats
      setIssueStats({
        totalIssues: 0,
        resolved: 0,
        pending: 0,
        inProgress: 0,
        rejected: 0,
        closed: 0
      });
    }
  };

  const checkUserLimitBeforeCreate = async () => {
    try {
      const token = sessionStorage.getItem('token');
      const headers = {
        Authorization: `Bearer ${token}`,
      };

      const normalizeList = (payload) =>
        Array.isArray(payload?.data) ? payload.data :
        Array.isArray(payload) ? payload : [];

      const [
        invoicesRes,
        approvedStaffRes,
        approvedAssetUsersRes,
        pendingStaffRes,
        pendingAssetUsersRes
      ] = await Promise.all([
        axios.get(API_ENDPOINTS.LAB_ADMIN_INVOICES, { headers }),
        axios.get(API_ENDPOINTS.LAB_ADMIN_APPROVED_USERS, { headers }),
        axios.get(`${API_ENDPOINTS.LAB_ADMIN_APPROVED_USERS}?role=asset_user`, { headers }),
        axios.get(API_ENDPOINTS.LAB_ADMIN_PENDING_USERS, { headers }),
        axios.get(`${API_ENDPOINTS.LAB_ADMIN_PENDING_USERS}?role=asset_user`, { headers })
      ]);

      const invoicesData = normalizeList(invoicesRes.data);
      const maxUsers = Number(invoicesData?.[0]?.limits?.users || 0);

      // If no plan limit is configured, allow creation and let backend decide.
      if (!Number.isFinite(maxUsers) || maxUsers <= 0) {
        return true;
      }

      const approvedStaff = normalizeList(approvedStaffRes.data).length;
      const approvedAssetUsers = normalizeList(approvedAssetUsersRes.data).length;
      const pendingStaff = normalizeList(pendingStaffRes.data).length;
      const pendingAssetUsers = normalizeList(pendingAssetUsersRes.data).length;

      const totalBillableUsers = approvedStaff + approvedAssetUsers + pendingStaff + pendingAssetUsers;

      if (totalBillableUsers >= maxUsers) {
        const msg = `User limit reached for current plan. Allowed: ${maxUsers}, Total users (incl. pending): ${totalBillableUsers}.`;
        setError(msg);
        openPlanLimitPopup('Renew or Upgrade Plan', msg, 'users');
        setTimeout(() => setError(''), 3500);
        return false;
      }

      return true;
    } catch (error) {
      // If pre-check fails, proceed and rely on backend enforcement.
      console.error('User limit pre-check failed:', error);
      return true;
    }
  };

  const handleAddTechnician = async (e) => {
    e.preventDefault();
    
    if (addTechnicianForm.password !== addTechnicianForm.confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    const canCreate = await checkUserLimitBeforeCreate();
    if (!canCreate) return;

    try {
      const token = sessionStorage.getItem('token');
      await axios.post(
        API_ENDPOINTS.AUTH_SIGNUP,
        {
          firstName: addTechnicianForm.firstName,
          lastName: addTechnicianForm.lastName,
          email: addTechnicianForm.email,
          password: addTechnicianForm.password,
          confirmPassword: addTechnicianForm.confirmPassword,
          role: 'asset_technician',
          skills: addTechnicianForm.skills
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setSuccessMessage('Lab Technician added successfully!');
      setAddTechnicianForm({
        firstName: '',
        lastName: '',
        email: '',
        password: '',
        confirmPassword: '',
        skills: []
      });
      setTimeout(() => setSuccessMessage(''), 3000);
      
      // Refresh pending users to update stats
      setTimeout(() => {
        fetchPendingUsers();
      }, 1000);
    } catch (error) {
      const payload = error.response?.data || {};
      const message = payload.message || 'Error adding technician';
      setError(message);
      if (isPlanActionError(payload)) {
        openPlanLimitPopup('Renew or Upgrade Plan', message, payload.limitType || 'users');
      }
      setTimeout(() => setError(''), 3000);
    }
  };

  const handleAddAssistant = async (e) => {
    e.preventDefault();
    
    if (addAssistantForm.password !== addAssistantForm.confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    const canCreate = await checkUserLimitBeforeCreate();
    if (!canCreate) return;

    try {
      const token = sessionStorage.getItem('token');
      await axios.post(
        API_ENDPOINTS.AUTH_SIGNUP,
        {
          firstName: addAssistantForm.firstName,
          lastName: addAssistantForm.lastName,
          email: addAssistantForm.email,
          password: addAssistantForm.password,
          confirmPassword: addAssistantForm.confirmPassword,
          role: 'asset_incharge'
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setSuccessMessage('Asset Incharge added successfully!');
      setAddAssistantForm({
        firstName: '',
        lastName: '',
        email: '',
        password: '',
        confirmPassword: ''
      });
      setTimeout(() => setSuccessMessage(''), 3000);
      
      // Refresh pending users to update stats
      setTimeout(() => fetchPendingUsers(), 1000);
    } catch (error) {
      const payload = error.response?.data || {};
      const message = payload.message || 'Error adding assistant';
      setError(message);
      if (isPlanActionError(payload)) {
        openPlanLimitPopup('Renew or Upgrade Plan', message, payload.limitType || 'users');
      }
      setTimeout(() => setError(''), 3000);
    }
  };

  const handleAddAssetUser = async (e) => {
    e.preventDefault();

    if (addAssetUserForm.password !== addAssetUserForm.confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    const canCreate = await checkUserLimitBeforeCreate();
    if (!canCreate) return;

    try {
      const token = sessionStorage.getItem('token');
      await axios.post(
        API_ENDPOINTS.AUTH_SIGNUP,
        {
          firstName: addAssetUserForm.firstName,
          lastName: addAssetUserForm.lastName,
          email: addAssetUserForm.email,
          password: addAssetUserForm.password,
          confirmPassword: addAssetUserForm.confirmPassword,
          role: 'asset_user'
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setSuccessMessage('Asset User added successfully!');
      setAddAssetUserForm({
        firstName: '',
        lastName: '',
        email: '',
        password: '',
        confirmPassword: ''
      });
      setTimeout(() => setSuccessMessage(''), 3000);

      setTimeout(() => fetchPendingUsers(), 1000);
    } catch (error) {
      const payload = error.response?.data || {};
      const message = payload.message || 'Error adding asset user';
      setError(message);
      if (isPlanActionError(payload)) {
        openPlanLimitPopup('Renew or Upgrade Plan', message, payload.limitType || 'users');
      }
      setTimeout(() => setError(''), 3000);
    }
  };

  const handleSkillChange = (skill) => {
    setAddTechnicianForm(prev => {
      const skills = prev.skills.includes(skill)
        ? prev.skills.filter(s => s !== skill)
        : [...prev.skills, skill];
      return { ...prev, skills };
    });
  };

  const fetchSkills = async () => {
    try {
      const response = await skillService.getAllSkills();
      if (response.success) {
        setSkillsOptions(response.data);
      }
    } catch (err) {
      // Error fetching skills
    }
  };

  const handleAddCustomSkill = async () => {
    const trimmed = newSkillName.trim();
    if (!trimmed) return;
    try {
      const response = await skillService.addSkill(trimmed, trimmed);
      if (response.success) {
        await fetchSkills();
        setNewSkillName('');
        setSuccessMessage(`Skill "${trimmed}" added successfully!`);
        setTimeout(() => setSuccessMessage(''), 3000);
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Error adding skill');
      setTimeout(() => setError(''), 3000);
    }
  };

  const handleDeleteSkill = async (skillId) => {
    if (!window.confirm('Are you sure you want to delete this skill?')) return;
    try {
      await skillService.deleteSkill(skillId);
      await fetchSkills();
      setSuccessMessage('Skill deleted successfully!');
      setTimeout(() => setSuccessMessage(''), 3000);
    } catch (err) {
      setError(err.response?.data?.message || 'Error deleting skill');
      setTimeout(() => setError(''), 3000);
    }
  };

  const handleEditSkill = async (skillId) => {
    try {
      if (!editedSkillName.trim()) {
        setError('Skill name cannot be empty');
        setTimeout(() => setError(''), 3000);
        return;
      }
      await skillService.updateSkill(skillId, editedSkillName.trim(), editedSkillName.trim());
      await fetchSkills();
      setSuccessMessage('Skill updated successfully!');
      setTimeout(() => setSuccessMessage(''), 3000);
      setEditingSkillId(null);
      setEditedSkillName('');
    } catch (err) {
      setError(err.response?.data?.message || 'Error updating skill');
      setTimeout(() => setError(''), 3000);
    }
  };

  // ── Asset Categories ──
  const fetchCategories = async () => {
    try {
      const token = sessionStorage.getItem('token');
      const response = await axios.get(API_ENDPOINTS.LAB_ADMIN_ASSET_CATEGORIES, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = Array.isArray(response.data) ? response.data : (response.data?.data || []);
      setCategories(data);
    } catch (err) {
      console.error('Error fetching categories:', err);
    }
  };

  const handleAddCategory = async () => {
    const trimmed = newCategoryName.trim();
    if (!trimmed) return;
    try {
      const token = sessionStorage.getItem('token');
      await axios.post(
        API_ENDPOINTS.LAB_ADMIN_ASSET_CATEGORIES,
        { name: trimmed },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setNewCategoryName('');
      setSuccessMessage(`Category "${trimmed}" added successfully!`);
      setTimeout(() => setSuccessMessage(''), 3000);
      await fetchCategories();
    } catch (err) {
      setError(err.response?.data?.message || 'Error adding category');
      setTimeout(() => setError(''), 3000);
    }
  };

  const handleEditCategory = async (categoryId) => {
    try {
      if (!editedCategoryName.trim()) {
        setError('Category name cannot be empty');
        setTimeout(() => setError(''), 3000);
        return;
      }
      const token = sessionStorage.getItem('token');
      await axios.put(
        `${API_ENDPOINTS.LAB_ADMIN_ASSET_CATEGORIES}/${categoryId}`,
        { name: editedCategoryName.trim() },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setSuccessMessage('Category updated successfully!');
      setTimeout(() => setSuccessMessage(''), 3000);
      setEditingCategoryId(null);
      setEditedCategoryName('');
      await fetchCategories();
    } catch (err) {
      setError(err.response?.data?.message || 'Error updating category');
      setTimeout(() => setError(''), 3000);
    }
  };

  const handleDeleteCategory = async (categoryId) => {
    if (!window.confirm('Are you sure you want to delete this category?')) return;
    try {
      const token = sessionStorage.getItem('token');
      await axios.delete(
        `${API_ENDPOINTS.LAB_ADMIN_ASSET_CATEGORIES}/${categoryId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setSuccessMessage('Category deleted successfully!');
      setTimeout(() => setSuccessMessage(''), 3000);
      await fetchCategories();
    } catch (err) {
      setError(err.response?.data?.message || 'Error deleting category');
      setTimeout(() => setError(''), 3000);
    }
  };

  // ── SubCategories ──
  const fetchSubCategories = async (categoryId) => {
    if (!categoryId) {
      setSubCategories([]);
      return;
    }
    try {
      const token = sessionStorage.getItem('token');
      const response = await axios.get(`${API_ENDPOINTS.LAB_ADMIN_SUBCATEGORIES}/${categoryId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = Array.isArray(response.data) ? response.data : (response.data?.data || []);
      setSubCategories(data);
    } catch (err) {
      console.error('Error fetching subcategories:', err);
      setSubCategories([]);
    }
  };

  const handleAddSubCategory = async () => {
    const trimmed = newSubCategoryName.trim();
    if (!trimmed || !selectedCategoryId) {
      setError('Please enter subcategory name and select a category');
      setTimeout(() => setError(''), 3000);
      return;
    }
    try {
      const token = sessionStorage.getItem('token');
      await axios.post(
        API_ENDPOINTS.LAB_ADMIN_SUBCATEGORIES,
        { name: trimmed, categoryId: selectedCategoryId },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setNewSubCategoryName('');
      setSuccessMessage(`Subcategory "${trimmed}" added successfully!`);
      setTimeout(() => setSuccessMessage(''), 3000);
      await fetchSubCategories(selectedCategoryId);
    } catch (err) {
      setError(err.response?.data?.message || 'Error adding subcategory');
      setTimeout(() => setError(''), 3000);
    }
  };

  const handleEditSubCategory = async (subCategoryId) => {
    try {
      if (!editedSubCategoryName.trim()) {
        setError('Subcategory name cannot be empty');
        setTimeout(() => setError(''), 3000);
        return;
      }
      const token = sessionStorage.getItem('token');
      await axios.put(
        `${API_ENDPOINTS.LAB_ADMIN_SUBCATEGORIES}/${subCategoryId}`,
        { name: editedSubCategoryName.trim() },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setSuccessMessage('Subcategory updated successfully!');
      setTimeout(() => setSuccessMessage(''), 3000);
      setEditingSubCategoryId(null);
      setEditedSubCategoryName('');
      await fetchSubCategories(selectedCategoryId);
    } catch (err) {
      setError(err.response?.data?.message || 'Error updating subcategory');
      setTimeout(() => setError(''), 3000);
    }
  };

  const handleDeleteSubCategory = async (subCategoryId) => {
    if (!window.confirm('Are you sure you want to delete this subcategory and all its specifications?')) return;
    try {
      const token = sessionStorage.getItem('token');
      await axios.delete(
        `${API_ENDPOINTS.LAB_ADMIN_SUBCATEGORIES}/${subCategoryId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setSuccessMessage('Subcategory deleted successfully!');
      setTimeout(() => setSuccessMessage(''), 3000);
      await fetchSubCategories(selectedCategoryId);
      setSelectedSubCategoryId('');
      setSpecifications([]);
    } catch (err) {
      setError(err.response?.data?.message || 'Error deleting subcategory');
      setTimeout(() => setError(''), 3000);
    }
  };

  // ── Specifications ──
  const fetchSpecifications = async (subCategoryId) => {
    if (!subCategoryId) {
      setSpecifications([]);
      return;
    }
    try {
      const token = sessionStorage.getItem('token');
      const response = await axios.get(`${API_ENDPOINTS.LAB_ADMIN_SPECIFICATIONS}/${subCategoryId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = Array.isArray(response.data) ? response.data : (response.data?.data || []);
      setSpecifications(data);
    } catch (err) {
      console.error('Error fetching specifications:', err);
      setSpecifications([]);
    }
  };

  const handleAddSpecification = async () => {
    const trimmed = newSpecificationName.trim();
    if (!trimmed || !selectedSubCategoryId) {
      setError('Please enter specification name and select a subcategory');
      setTimeout(() => setError(''), 3000);
      return;
    }
    try {
      const token = sessionStorage.getItem('token');
      await axios.post(
        API_ENDPOINTS.LAB_ADMIN_SPECIFICATIONS,
        { 
          name: trimmed, 
          subCategoryId: selectedSubCategoryId,
          categoryId: selectedCategoryId 
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setNewSpecificationName('');
      setSuccessMessage(`Specification "${trimmed}" added successfully!`);
      setTimeout(() => setSuccessMessage(''), 3000);
      await fetchSpecifications(selectedSubCategoryId);
    } catch (err) {
      setError(err.response?.data?.message || 'Error adding specification');
      setTimeout(() => setError(''), 3000);
    }
  };

  const handleEditSpecification = async (specificationId) => {
    try {
      if (!editedSpecificationName.trim()) {
        setError('Specification name cannot be empty');
        setTimeout(() => setError(''), 3000);
        return;
      }
      const token = sessionStorage.getItem('token');
      await axios.put(
        `${API_ENDPOINTS.LAB_ADMIN_SPECIFICATIONS}/${specificationId}`,
        { name: editedSpecificationName.trim() },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setSuccessMessage('Specification updated successfully!');
      setTimeout(() => setSuccessMessage(''), 3000);
      setEditingSpecificationId(null);
      setEditedSpecificationName('');
      await fetchSpecifications(selectedSubCategoryId);
    } catch (err) {
      setError(err.response?.data?.message || 'Error updating specification');
      setTimeout(() => setError(''), 3000);
    }
  };

  const handleDeleteSpecification = async (specificationId) => {
    if (!window.confirm('Are you sure you want to delete this specification?')) return;
    try {
      const token = sessionStorage.getItem('token');
      await axios.delete(
        `${API_ENDPOINTS.LAB_ADMIN_SPECIFICATIONS}/${specificationId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setSuccessMessage('Specification deleted successfully!');
      setTimeout(() => setSuccessMessage(''), 3000);
      await fetchSpecifications(selectedSubCategoryId);
    } catch (err) {
      setError(err.response?.data?.message || 'Error deleting specification');
      setTimeout(() => setError(''), 3000);
    }
  };

  // ── Departments ──
  const fetchDepartments = async () => {
    try {
      const res = await departmentService.getAllDepartments();
      setDepartments(res.data || []);
      // Update stats with departments count
      setApprovalStats(prev => ({
        ...prev,
        totalDepartments: (res.data || []).length
      }));
    } catch (err) {
      console.error('Error fetching departments:', err);
    }
  };

  const updateDepartmentsCount = () => {
    setApprovalStats(prev => ({
      ...prev,
      totalDepartments: departments.length
    }));
  };

  const handleAddDepartment = async () => {
    const trimmed = newDeptLabel.trim();
    if (!trimmed) return;
    try {
      const name = trimmed.toLowerCase().replace(/\s+/g, '_');
      await departmentService.addDepartment(name, trimmed);
      setNewDeptLabel('');
      setSuccessMessage(`Department "${trimmed}" added successfully!`);
      setTimeout(() => setSuccessMessage(''), 3000);
      await fetchDepartments();
    } catch (err) {
      setError(err.response?.data?.message || 'Error adding department');
      setTimeout(() => setError(''), 3000);
    }
  };

  const handleDeleteDepartment = async (id) => {
    try {
      await departmentService.deleteDepartment(id);
      setSuccessMessage('Department deleted successfully!');
      setTimeout(() => setSuccessMessage(''), 3000);
      await fetchDepartments();
    } catch (err) {
      setError('Error deleting department');
      setTimeout(() => setError(''), 3000);
    }
  };

  const handleEditDepartment = async (id) => {
    try {
      if (!editedDeptName.trim()) {
        setError('Department name cannot be empty');
        setTimeout(() => setError(''), 3000);
        return;
      }
      const deptToEdit = departments.find(d => d._id === id);
      if (!deptToEdit) return;

      const name = editedDeptName.trim().toLowerCase().replace(/\s+/g, '_');
      const displayName = editedDeptName.trim();
      
      await departmentService.updateDepartment(id, name, displayName);
      setSuccessMessage('Department updated successfully!');
      setTimeout(() => setSuccessMessage(''), 3000);
      setEditingDeptId(null);
      setEditedDeptName('');
      await fetchDepartments();
      await fetchApprovedUsers();
    } catch (err) {
      setError(err.response?.data?.message || 'Error updating department');
      setTimeout(() => setError(''), 3000);
    }
  };

  const handleUnassignDepartment = async (userId) => {
    try {
      const token = sessionStorage.getItem('token');
      await axios.patch(
        API_ENDPOINTS.LAB_ADMIN_ASSIGN_DEPARTMENT,
        {
          userId: userId,
          department: ''
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setSuccessMessage('Department unassigned successfully!');
      setTimeout(() => setSuccessMessage(''), 3000);
      await fetchApprovedUsers();
    } catch (err) {
      setError(err.response?.data?.message || 'Error unassigning department');
      setTimeout(() => setError(''), 3000);
    }
  };

  const handleAssignDepartment = async (e) => {
    e.preventDefault();
    if (!assignDeptForm.departmentId || !assignDeptForm.assetInchargeId) {
      setError('Please select both department and asset incharge');
      return;
    }
    try {
      const token = sessionStorage.getItem('token');
      await axios.patch(
        API_ENDPOINTS.LAB_ADMIN_ASSIGN_DEPARTMENT,
        {
          userId: assignDeptForm.assetInchargeId,
          department: assignDeptForm.departmentId
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setSuccessMessage('Department assigned to asset incharge successfully!');
      setAssignDeptForm({ departmentId: '', assetInchargeId: '' });
      setTimeout(() => setSuccessMessage(''), 3000);
      await fetchApprovedUsers();
    } catch (err) {
      setError(err.response?.data?.message || 'Error assigning department');
      setTimeout(() => setError(''), 3000);
    }
  };

  // ── Asset User Requests ──
  const fetchAssetUserRequests = async () => {
    try {
      const token = sessionStorage.getItem('token');
      const response = await axios.get(
        `${API_ENDPOINTS.LAB_ADMIN_ASSET_USER_REQUESTS}?status=pending`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      const data = response.data?.data || (Array.isArray(response.data) ? response.data : []);
      
      // Update stats with pending asset user requests count
      setApprovalStats(prev => ({
        ...prev,
        pendingAssetUserRequests: data.length
      }));
    } catch (err) {
      console.error('Error fetching asset user requests:', err);
    }
  };

  const fetchApprovedAssetUsers = async () => {
    try {
      const token = sessionStorage.getItem('token');
      const response = await axios.get(API_ENDPOINTS.LAB_ADMIN_APPROVED_ASSET_USERS, {
        headers: { Authorization: `Bearer ${token}` },
      });
      let data = Array.isArray(response.data) ? response.data : (response.data?.data || []);
      setAssetUsers(data);
      
      // Update stats with approved asset users count
      setApprovalStats(prev => ({
        ...prev,
        approvedAssetUsers: data.length
      }));
    } catch (err) {
      console.error('Error fetching approved asset users:', err);
      setAssetUsers([]);
    }
  }


  const refreshData = async () => {
    
    setRefreshing(true);
    try {
      await fetchPendingUsers();
      await fetchApprovedUsers();
      await fetchIssuesStats();
      setSuccessMessage('Dashboard data refreshed!');
      setTimeout(() => setSuccessMessage(''), 2000);
    } catch (error) {
      console.error('Error refreshing data:', error);
      setError('Failed to refresh data');
      setTimeout(() => setError(''), 3000);
    } finally {
      setRefreshing(false);
    }
  };

  if (loading) {
    return <div className="admin-loading">Loading admin dashboard...</div>;
  }

  return (
    <div className="lab-admin-container">
      {/* Sidebar */}
      <div className={`admin-sidebar ${sidebarCollapsed ? 'collapsed' : ''}`}>
        {/* Collapse Toggle Button */}
        <button 
          className="sidebar-toggle-btn"
          onClick={() => setSidebarCollapsed(!sidebarCollapsed)}
          title={sidebarCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}
        >
          {sidebarCollapsed ? <FaBars /> : <FaTimes />}
        </button>

        {/* Profile Section */}
        
        {/* Navigation */}
        <nav className="sidebar-nav">
          <button
            className={`nav-btn ${activeSection === 'dashboard' ? 'active' : ''}`}
            onClick={() => setActiveSection('dashboard')}
            title="Dashboard"
          >
            <FaTachometerAlt className="nav-icon" />
            <span>Dashboard</span>
          </button>
          <button
            className={`nav-btn ${activeSection === 'approvals' ? 'active' : ''}`}
            onClick={() => setActiveSection('approvals')}
            title="Pending Approvals"
          >
            <FaUserClock className="nav-icon" />
            <span>Pending Approvals ({pendingUsers.length})</span>
          </button>
          
          <button
            className={`nav-btn ${activeSection === 'manage-users' ? 'active' : ''}`}
            onClick={() => setActiveSection('manage-users')}
            title="Manage Users"
          >
            <FaUsers className="nav-icon" />
            <span>Manage Users</span>
          </button>
          <button
            className={`nav-btn ${activeSection === 'manage-skills' ? 'active' : ''}`}
            onClick={() => setActiveSection('manage-skills')}
            title="Manage Skills"
          >
            <FaCogs className="nav-icon" />
            <span>Manage Technician Skills Requirements</span>
          </button>
          <button
            className={`nav-btn ${activeSection === 'manage-categories' ? 'active' : ''}`}
            onClick={() => setActiveSection('manage-categories')}
            title="Add Categories"
          >
            <FaFolderPlus className="nav-icon" />
            <span>Add Categories</span>
          </button>
          <button
            className={`nav-btn ${activeSection === 'manage-subcategories' ? 'active' : ''}`}
            onClick={() => setActiveSection('manage-subcategories')}
            title="Manage Subcategories"
          >
            <FaEllipsisV className="nav-icon" />
            <span>Manage Subcategories & Specifications</span>
          </button>
          <button
            className={`nav-btn ${activeSection === 'manage-departments' ? 'active' : ''}`}
            onClick={() => setActiveSection('manage-departments')}
            title="Manage Departments"
          >
            <FaBuilding className="nav-icon" />
            <span>Manage Departments</span>
          </button>

          <button
            className={`nav-btn ${activeSection === 'manage-suppliers' ? 'active' : ''}`}
            onClick={() => setActiveSection('manage-suppliers')}
            title="Manage Suppliers"
          >
            <FaTruck className="nav-icon" />
            <span>Manage Suppliers</span>
          </button>

          <button
            className={`nav-btn ${activeSection === 'view-assets-inventory' ? 'active' : ''}`}
            onClick={() => setActiveSection('view-assets-inventory')}
            title="View Assets"
          >
            <FaWarehouse className="nav-icon" />
            <span>View Assets Inventory</span>
          </button>
      
          <button
            className={`nav-btn ${activeSection === 'admin-profile' ? 'active' : ''}`}
            onClick={() => setActiveSection('admin-profile')}
            title="Company Details"
          >
            <FaUser className="nav-icon" />
            <span>Company Details</span>
          </button>
      
          <button
            className={`nav-btn ${activeSection === 'view-plans' ? 'active' : ''}`}
            onClick={() => setActiveSection('view-plans')}
            title="View Plans"
          >
            <FaCreditCard className="nav-icon" />
            <span>View Plans</span>
          </button>

          <button
            className={`nav-btn ${activeSection === 'manage-invoices' ? 'active' : ''}`}
            onClick={() => setActiveSection('manage-invoices')}
            title="Manage Invoices"
          >
            <FaCreditCard className="nav-icon" />
            <span>Manage Invoices</span>
          </button>

          <button
            className={`nav-btn ${activeSection === 'download-data' ? 'active' : ''}`}
            onClick={() => setActiveSection('download-data')}
            title="Download Data"
          >
            <FaDownload className="nav-icon" />
            <span>Download your data</span>
          </button>
      
        </nav>
      </div>

      {/* Main Content */}
      <div className="admin-content">
        {/* Alerts */}
        {error && (
          <div className="alert alert-error">
            <strong>Error:</strong> {error}
          </div>
        )}
        {successMessage && (
          <div className="alert alert-success">
            <strong>Success:</strong> {successMessage}
          </div>
        )}

        {/* Dashboard Section */}
        {activeSection === 'dashboard' && (
          <div className="section-content">
            {/* Dashboard Header with Company Info */}
            <div className="dashboard-header-new">
              <div className="dashboard-header-left">
                <h1 className="dashboard-title">Dashboard Overview</h1>
                <p className="dashboard-subtitle">System analytics and key metrics</p>
              </div>
              <button 
                className={`refresh-btn ${refreshing ? 'refreshing' : ''}`}
                onClick={refreshData}
                disabled={refreshing}
                title="Refresh dashboard data"
              >
                <FaSync />
                {refreshing ? 'Refreshing...' : 'Refresh'}
              </button>
            </div>

            {/* System Summary Statistics - MOVED UP */}
            <div className="summary-section-new" style={{ marginTop: '20px', marginBottom: '30px' }}>
              <h2 className="summary-title">System Overview</h2>
              <div className="summary-grid">
                <div className="summary-card">
                  <div className="summary-card-header">
                    <FaCogs className="summary-icon" />
                    <h4>Staff Members</h4>
                  </div>
                  <p className="summary-value">{(approvalStats.totalTechnicians || 0) + (approvalStats.totalAssistants || 0)}</p>
                  <p className="summary-status">Technicians & Incharges</p>
                </div>

                <div className="summary-card">
                  <div className="summary-card-header">
                    <FaClipboard className="summary-icon" />
                    <h4>Total Issues</h4>
                  </div>
                  <p className="summary-value">{issueStats.totalIssues || 0}</p>
                  <p className="summary-status">All reported issues</p>
                </div>

                <div className="summary-card">
                  <div className="summary-card-header">
                    <FaCheckCircle className="summary-icon" />
                    <h4>Resolved</h4>
                  </div>
                  <p className="summary-value">{issueStats.resolved || 0}</p>
                  <p className="summary-status">Successfully closed</p>
                </div>

                <div className="summary-card">
                  <div className="summary-card-header">
                    <FaClock className="summary-icon" />
                    <h4>Pending Action</h4>
                  </div>
                  <p className="summary-value">{(approvalStats.pendingRequests || 0) + (issueStats.pending || 0)}</p>
                  <p className="summary-status">Approvals & open issues</p>
                </div>
              </div>
            </div>

            {/* Charts Section - Simplified Layout */}
            <div className="charts-grid-new">
              {/* Staff Details Info Table */}
              <div className="chart-card-new">
                <div className="chart-card-header-new">
                  <h3>Team Composition</h3>
                  <p className="chart-card-subtitle">Staff breakdown</p>
                </div>
                <div className="info-table-container">
                  <table className="info-table">
                    <tbody>
                      <tr>
                        <td className="label">Technicians</td>
                        <td className="value" style={{ color: '#6366f1' }}>{approvalStats.totalTechnicians || 0}</td>
                      </tr>
                      <tr>
                        <td className="label">Incharges</td>
                        <td className="value" style={{ color: '#8b5cf6' }}>{approvalStats.totalAssistants || 0}</td>
                      </tr>
                      <tr>
                    <td className="label">Asset users</td>
                         <td className="value" style={{ color: '#8b5cf6' }}>{approvalStats.approvedAssetUsers || 0}</td>
                      </tr>
                      <tr>
                        <td className="label">Pending Approvals</td>
                        <td className="value" style={{ color: '#f59e0b' }}>{approvalStats.pendingRequests || 0}</td>

                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              {/* Issues Status Pie Chart */}
              <div className="chart-card-new">
                <div className="chart-card-header-new">
                  <h3>Issue Distribution</h3>
                  <p className="chart-card-subtitle">Status breakdown</p>
                </div>
                <div className="chart-container-new">
                  {issueStats.totalIssues === 0 ? (
                    <div style={{ textAlign: 'center', padding: '40px 20px', color: '#9ca3af' }}>
                      No issue data available
                    </div>
                  ) : (
                    <ResponsiveContainer width="100%" height={280}>
                      <PieChart>
                        <Pie
                          data={[
                            { name: 'Resolved', value: issueStats.resolved || 0 },
                            { name: 'In Progress', value: issueStats.inProgress || 0 },
                            { name: 'Pending', value: issueStats.pending || 0 },
                            { name: 'Closed', value: (issueStats.closed || 0) + (issueStats.rejected || 0) }
                          ]}
                          cx="50%"
                          cy="50%"
                          labelLine={false}
                          label={({ name, value }) => value > 0 ? `${name}: ${value}` : null}
                          outerRadius={80}
                          dataKey="value"
                        >
                          <Cell fill="#d1fae5" />
                          <Cell fill="#fca5a5" />
                          <Cell fill="#fed7aa" />
                          <Cell fill="#c7d2ff" />
                        </Pie>
                        <Tooltip formatter={(value) => value} />
                      </PieChart>
                    </ResponsiveContainer>
                  )}
                </div>
              </div>
            </div>

            {/* Issues Details Info Table & Status Bar Chart */}
            <div className="charts-grid-new">
              {/* Issues Detailed Breakdown */}
              <div className="chart-card-new">
                <div className="chart-card-header-new">
                  <h3>Issue Details</h3>
                  <p className="chart-card-subtitle">Count by status</p>
                </div>
                <div className="info-table-container">
                  <table className="info-table">
                    <tbody>
                      <tr>
                        <td className="label">Resolved</td>
                        <td className="value" style={{ color: '#10b981' }}>{issueStats.resolved || 0}</td>
                      </tr>
                      <tr>
                        <td className="label">In Progress</td>
                        <td className="value" style={{ color: '#ef4444' }}>{issueStats.inProgress || 0}</td>
                      </tr>
                      <tr>
                        <td className="label">Pending</td>
                        <td className="value" style={{ color: '#f59e0b' }}>{issueStats.pending || 0}</td>
                      </tr>
                      <tr>
                        <td className="label">Closed/Rejected</td>
                        <td className="value" style={{ color: '#6b7280' }}>{(issueStats.closed || 0) + (issueStats.rejected || 0)}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              {/* Issue Status Bar Chart */}
              <div className="chart-card-new">
                <div className="chart-card-header-new">
                  <h3>Issue Completion Rate</h3>
                  <p className="chart-card-subtitle">Visual comparison</p>
                </div>
                <div className="chart-container-new">
                  <ResponsiveContainer width="100%" height={280}>
                    <BarChart data={[
                      { name: 'Resolved', value: issueStats.resolved || 0, fill: '#d1fae5' },
                      { name: 'In Progress', value: issueStats.inProgress || 0, fill: '#fca5a5' },
                      { name: 'Pending', value: issueStats.pending || 0, fill: '#fed7aa' },
                      { name: 'Closed', value: (issueStats.closed || 0) + (issueStats.rejected || 0), fill: '#c7d2ff' }
                    ]}>
                      <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
                      <XAxis dataKey="name" stroke="#6b7280" />
                      <YAxis stroke="#6b7280" />
                      <Tooltip 
                        contentStyle={{ backgroundColor: '#fff', border: '1px solid #e5e7eb', borderRadius: '8px' }}
                        cursor={{ fill: 'rgba(0, 0, 0, 0.05)' }}
                      />
                      <Bar dataKey="value" radius={[8, 8, 0, 0]} />
                    </BarChart>
                  </ResponsiveContainer>
                </div>
              </div>
            </div>

            {/* Additional Dashboard Statistics & Charts */}
            <div className="charts-grid-new">
              {/* Approval Efficiency Stats with Trend Chart */}
              <div className="chart-card-new">
                <div className="chart-card-header-new">
                  <h3>Approval Efficiency & Trends</h3>
                  <p className="chart-card-subtitle">Performance & trend analysis</p>
                </div>
                <div style={{ display: 'flex', gap: '20px', alignItems: 'stretch' }}>
                  {/* Left side: Table */}
                  <div className="info-table-container" style={{ flex: 1, minWidth: '180px' }}>
                    <table className="info-table">
                      <tbody>
                        <tr>
                          <td className="label">Total Approvals</td>
                          <td className="value" style={{ color: '#3b82f6' }}>{(approvalStats.totalTechnicians || 0) + (approvalStats.totalAssistants || 0)}</td>
                        </tr>
                        <tr>
                          <td className="label">Pending Approvals</td>
                          <td className="value" style={{ color: '#f59e0b' }}>{approvalStats.pendingRequests || 0}</td>
                        </tr>
                        <tr>
                          <td className="label">Approval Rate</td>
                          <td className="value" style={{ color: '#10b981' }}>
                            {((approvalStats.totalTechnicians + approvalStats.totalAssistants) / 
                              ((approvalStats.totalTechnicians + approvalStats.totalAssistants + approvalStats.pendingRequests) || 1) * 100).toFixed(1)}%
                          </td>
                        </tr>
                        <tr>
                          <td className="label">Asset Users</td>
                          <td className="value" style={{ color: '#8b5cf6' }}>{approvalStats.approvedAssetUsers || 0}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  {/* Right side: Line Chart */}
                
                </div>
                
              </div>
              

              {/* Issue Resolution Analytics */}
               <div style={{ flex: 1, minWidth: '250px' }} className='chart-card-new'>
                    <ResponsiveContainer width="100%" height={240}>
                      <LineChart
                        data={[
                          { week: 'Week 1', approved: Math.max(0, (approvalStats.totalTechnicians + approvalStats.totalAssistants) - 4), pending: Math.min(approvalStats.pendingRequests + 2, 8) },
                          { week: 'Week 2', approved: Math.max(0, (approvalStats.totalTechnicians + approvalStats.totalAssistants) - 2), pending: Math.min(approvalStats.pendingRequests + 1, 8) },
                          { week: 'Week 3', approved: (approvalStats.totalTechnicians + approvalStats.totalAssistants) - 1, pending: approvalStats.pendingRequests },
                          { week: 'Week 4', approved: (approvalStats.totalTechnicians + approvalStats.totalAssistants), pending: Math.max(0, approvalStats.pendingRequests - 1) }
                        ]}
                        margin={{ top: 5, right: 10, left: 0, bottom: 5 }}
                      >
                        <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
                        <XAxis dataKey="week" stroke="#6b7280" />
                        <YAxis stroke="#6b7280" />
                        <Tooltip contentStyle={{ backgroundColor: '#fff', border: '1px solid #e5e7eb', borderRadius: '8px' }} />
                        <Legend />
                        <Line 
                          type="monotone" 
                          dataKey="approved" 
                          stroke="#10b981" 
                          strokeWidth={2}
                          dot={{ fill: '#10b981', r: 4 }}
                          activeDot={{ r: 6 }}
                          name="Approved"
                        />
                        <Line 
                          type="monotone" 
                          dataKey="pending" 
                          stroke="#f59e0b" 
                          strokeWidth={2}
                          dot={{ fill: '#f59e0b', r: 4 }}
                          activeDot={{ r: 6 }}
                          name="Pending"
                        />
                      </LineChart>
                    </ResponsiveContainer>
                  </div>
            </div>

            {/* Staff & Department Metrics */}
            <div className="charts-grid-new">
              {/* Staff Distribution by Role */}
              <div className="chart-card-new">
                <div className="chart-card-header-new">
                  <h3>Staff Distribution</h3>
                  <p className="chart-card-subtitle">By role type</p>
                </div>
                <div className="chart-container-new">
                  <ResponsiveContainer width="100%" height={280}>
                    <PieChart>
                      <Pie
                        data={[
                          { name: 'Technicians', value: approvalStats.totalTechnicians || 0 },
                          { name: 'Incharges', value: approvalStats.totalAssistants || 0 },
                          { name: 'Asset Users', value: approvalStats.approvedAssetUsers || 0 }
                        ]}
                        cx="50%"
                        cy="50%"
                        labelLine={false}
                        label={({ name, value }) => value > 0 ? `${name}: ${value}` : null}
                        outerRadius={80}
                        dataKey="value"
                      >
                        <Cell fill="#6366f1" />
                        <Cell fill="#8b5cf6" />
                        <Cell fill="#10b981" />
                      </Pie>
                      <Tooltip formatter={(value) => value} />
                    </PieChart>
                  </ResponsiveContainer>
                </div>
              </div>

              {/* System Health Overview */}
              <div className="chart-card-new">
                <div className="chart-card-header-new">
                  <h3>System Health</h3>
                  <p className="chart-card-subtitle">Overall status</p>
                </div>
                <div className="info-table-container">
                  <table className="info-table">
                    <tbody>
                      <tr>
                        <td className="label">Total Departments</td>
                        <td className="value" style={{ color: '#3b82f6' }}>{approvalStats.totalDepartments || 0}</td>
                      </tr>
                      <tr>
                        <td className="label">Pending Asset Requests</td>
                        <td className="value" style={{ color: '#f59e0b' }}>{approvalStats.pendingAssetUserRequests || 0}</td>
                      </tr>
                      <tr>
                        <td className="label">System Status</td>
                        <td className="value" style={{ color: '#10b981' }}>✓ Operational</td>
                      </tr>
                      <tr>
                        <td className="label">Active Users</td>
                        <td className="value" style={{ color: '#8b5cf6' }}>{(approvalStats.totalTechnicians || 0) + (approvalStats.totalAssistants || 0) + (approvalStats.approvedAssetUsers || 0)}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            {/* Workload & Performance Charts */}
        

            {/* Summary Stats */}
            <div className="summary-section-new" style={{ display: 'none' }}>
              {/* This section is now moved to the top and hidden here to avoid duplication */}
            </div>

            {/* Quick Actions */}
            <div className="quick-actions-new">
              <h2 className="quick-actions-title">Quick Actions</h2>
              <div className="action-buttons-grid">
                <button 
                  className="action-btn-new action-btn-primary"
                  onClick={() => setActiveSection('approvals')}
                >
                  <FaCheckCircle />
                  Review Approvals
                </button>
                <button 
                  className="action-btn-new action-btn-secondary"
                  onClick={() => setActiveSection('add-technician')}
                >
                  <FaUserPlus />
                  Add Technician
                </button>
                <button 
                  className="action-btn-new action-btn-secondary"
                  onClick={() => setActiveSection('add-assistant')}
                >
                  <FaUserPlus />
                  Add Incharge
                </button>
                <button 
                  className="action-btn-new action-btn-secondary"
                  onClick={() => setActiveSection('add-asset-user')}
                >
                  <FaUserPlus />
                  Add Asset User
                </button>
              </div>
            </div>
          </div>
        )}

    
        {/* Add Technician Section */}
        {activeSection === 'add-technician' && (
          <div className="section-content">
            <div className="section-header-admin">
              <h1>Add New Lab Technician</h1>
              <p>Register a new lab technician to the system</p>
            </div>

            <form onSubmit={handleAddTechnician} className="form-container">
              <div className="form-row">
                <div className="form-group">
                  <label>First Name *</label>
                  <input
                    type="text"
                    value={addTechnicianForm.firstName}
                    onChange={(e) => setAddTechnicianForm({
                      ...addTechnicianForm,
                      firstName: e.target.value
                    })}
                    placeholder="Enter first name"
                    required
                  />
                </div>
                <div className="form-group">
                  <label>Last Name *</label>
                  <input
                    type="text"
                    value={addTechnicianForm.lastName}
                    onChange={(e) => setAddTechnicianForm({
                      ...addTechnicianForm,
                      lastName: e.target.value
                    })}
                    placeholder="Enter last name"
                    required
                  />
                </div>
              </div>

              <div className="form-group">
                <label>Email *</label>
                <input
                  type="email"
                  value={addTechnicianForm.email}
                  onChange={(e) => setAddTechnicianForm({
                    ...addTechnicianForm,
                    email: e.target.value
                  })}
                  placeholder="Enter email"
                  required
                />
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>Password *</label>
                  <input
                    type="password"
                    value={addTechnicianForm.password}
                    onChange={(e) => setAddTechnicianForm({
                      ...addTechnicianForm,
                      password: e.target.value
                    })}
                    placeholder="Enter password"
                    required
                  />
                </div>
                <div className="form-group">
                  <label>Confirm Password *</label>
                  <input
                    type="password"
                    value={addTechnicianForm.confirmPassword}
                    onChange={(e) => setAddTechnicianForm({
                      ...addTechnicianForm,
                      confirmPassword: e.target.value
                    })}
                    placeholder="Confirm password"
                    required
                  />
                </div>
              </div>

              <div className="form-group">
                <label>Technical Skills</label>
                <div className="skills-grid">
                  {skillsOptions.map((skill) => (
                    <label key={skill._id} className="skill-checkbox">
                      <input
                        type="checkbox"
                        checked={addTechnicianForm.skills.includes(skill.name)}
                        onChange={() => handleSkillChange(skill.name)}
                      />
                      <span>{skill.label}</span>
                    </label>
                  ))}
                </div>
                <div className="add-skill-inline">
                  <input
                    type="text"
                    value={newSkillName}
                    onChange={(e) => setNewSkillName(e.target.value)}
                    placeholder="Add new custom skill..."
                    onKeyPress={(e) => {
                      if (e.key === 'Enter') {
                        e.preventDefault();
                        handleAddCustomSkill();
                      }
                    }}
                  />
                  <button type="button" className="btn-add-skill" onClick={handleAddCustomSkill}>
                    + Add Skill
                  </button>
                </div>
              </div>

              <button type="submit" className="submit-btn">
                <FaUserPlus /> Add Technician
              </button>
            </form>
          </div>
        )}

        {/* User Approvals Section */}
        {activeSection === 'approvals' && (
          <UserApprovals user={user} />
        )}

        {/* Manage Users Section */}
        {activeSection === 'manage-users' && (
          <UserListings 
            approvedUsers={approvedUsers}
            assetUsers={assetUsers}
            onAddTechnician={() => setActiveSection('add-technician')}
            onAddAssistant={() => setActiveSection('add-assistant')}
            onAddAssetUser={() => setActiveSection('add-asset-user')}
            onImportUsers={() => setActiveSection('import-users')}
            onRefresh={() => {
              fetchApprovedUsers();
              fetchApprovedAssetUsers();
            }}
          />
        )}

        {/* Import Users Section */}
        {activeSection === 'import-users' && (
          <ImportFiles 
            importType="users"
            onImportSuccess={() => {
              fetchApprovedUsers();
              fetchApprovedAssetUsers();
            }}
          />
        )}

        {/* Manage Suppliers Section */}
        {activeSection === 'manage-suppliers' && (
          <SupplierDetails user={user} embedded={true} />
        )}

        {/* Add Assistant Section */}
        {activeSection === 'add-assistant' && (
          <div className="section-content">
            <div className="section-heade-adminr">
              <h1>Add New Asset Incharge</h1>
              <p>Register a new asset incharge to the system</p>
            </div>

            <form onSubmit={handleAddAssistant} className="form-container">
              <div className="form-row">
                <div className="form-group">
                  <label>First Name *</label>
                  <input
                    type="text"
                    value={addAssistantForm.firstName}
                    onChange={(e) => setAddAssistantForm({
                      ...addAssistantForm,
                      firstName: e.target.value
                    })}
                    placeholder="Enter first name"
                    required
                  />
                </div>
                <div className="form-group">
                  <label>Last Name *</label>
                  <input
                    type="text"
                    value={addAssistantForm.lastName}
                    onChange={(e) => setAddAssistantForm({
                      ...addAssistantForm,
                      lastName: e.target.value
                    })}
                    placeholder="Enter last name"
                    required
                  />
                </div>
              </div>

              <div className="form-group">
                <label>Email *</label>
                <input
                  type="email"
                  value={addAssistantForm.email}
                  onChange={(e) => setAddAssistantForm({
                    ...addAssistantForm,
                    email: e.target.value
                  })}
                  placeholder="Enter email"
                  required
                />
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>Password *</label>
                  <input
                    type="password"
                    value={addAssistantForm.password}
                    onChange={(e) => setAddAssistantForm({
                      ...addAssistantForm,
                      password: e.target.value
                    })}
                    placeholder="Enter password"
                    required
                  />
                </div>
                <div className="form-group">
                  <label>Confirm Password *</label>
                  <input
                    type="password"
                    value={addAssistantForm.confirmPassword}
                    onChange={(e) => setAddAssistantForm({
                      ...addAssistantForm,
                      confirmPassword: e.target.value
                    })}
                    placeholder="Confirm password"
                    required
                  />
                </div>
              </div>

              <button type="submit" className="submit-btn">
                <FaUserPlus /> Add Asset Incharge
              </button>
            </form>
          </div>
        )}

        {/* Add Asset User Section */}
        {activeSection === 'add-asset-user' && (
          <div className="section-content">
            <div className="section-header-admin">
              <h1>Add New Asset User</h1>
              <p>Register a new asset user to the system</p>
            </div>

            <form onSubmit={handleAddAssetUser} className="form-container">
              <div className="form-row">
                <div className="form-group">
                  <label>First Name *</label>
                  <input
                    type="text"
                    value={addAssetUserForm.firstName}
                    onChange={(e) => setAddAssetUserForm({
                      ...addAssetUserForm,
                      firstName: e.target.value
                    })}
                    placeholder="Enter first name"
                    required
                  />
                </div>
                <div className="form-group">
                  <label>Last Name *</label>
                  <input
                    type="text"
                    value={addAssetUserForm.lastName}
                    onChange={(e) => setAddAssetUserForm({
                      ...addAssetUserForm,
                      lastName: e.target.value
                    })}
                    placeholder="Enter last name"
                    required
                  />
                </div>
              </div>

              <div className="form-group">
                <label>Email *</label>
                <input
                  type="email"
                  value={addAssetUserForm.email}
                  onChange={(e) => setAddAssetUserForm({
                    ...addAssetUserForm,
                    email: e.target.value
                  })}
                  placeholder="Enter email"
                  required
                />
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>Password *</label>
                  <input
                    type="password"
                    value={addAssetUserForm.password}
                    onChange={(e) => setAddAssetUserForm({
                      ...addAssetUserForm,
                      password: e.target.value
                    })}
                    placeholder="Enter password"
                    required
                  />
                </div>
                <div className="form-group">
                  <label>Confirm Password *</label>
                  <input
                    type="password"
                    value={addAssetUserForm.confirmPassword}
                    onChange={(e) => setAddAssetUserForm({
                      ...addAssetUserForm,
                      confirmPassword: e.target.value
                    })}
                    placeholder="Confirm password"
                    required
                  />
                </div>
              </div>

              <button type="submit" className="submit-btn">
                <FaUserPlus /> Add Asset User
              </button>
            </form>
          </div>
        )}

        {/* Add Lab Section */}
      
        {/* Manage Labs Section */}
       

        {/* Manage SubCategories and Specifications Section */}
        {activeSection === 'manage-subcategories' && (
          <div className="section-content">
            <div className="section-header">
              <h1>Manage Subcategories and Specifications</h1>
              <p>Organize categories into subcategories and add specifications</p>
            </div>

            {/* Category Selection */}
            <div className="form-container" style={{ marginBottom: '24px' }}>
              <h3>Step 1: Select a Category</h3>
              <select
                value={selectedCategoryId}
                onChange={(e) => {
                  setSelectedCategoryId(e.target.value);
                  setSelectedSubCategoryId('');
                  setSpecifications([]);
                  fetchSubCategories(e.target.value);
                }}
                style={{
                  width: '100%',
                  padding: '10px',
                  border: '1px solid #ddd',
                  borderRadius: '4px',
                  fontSize: '14px',
                  marginBottom: '12px'
                }}
              >
                <option value="">-- Select a Category --</option>
                {categories.map((cat) => (
                  <option key={cat._id} value={cat._id}>
                    {cat.name}
                  </option>
                ))}
              </select>
            </div>

            {selectedCategoryId && (
              <>
                {/* SubCategories Section */}
                <div className="form-container" style={{ marginBottom: '24px' }}>
                  <h3>Step 2: Manage Subcategories for "{categories.find(c => c._id === selectedCategoryId)?.name}"</h3>
                  <div className="add-skill-inline">
                    <input
                      type="text"
                      value={newSubCategoryName}
                      onChange={(e) => setNewSubCategoryName(e.target.value)}
                      placeholder="Enter subcategory name (e.g., Laptops, Desktops)"
                      onKeyPress={(e) => {
                        if (e.key === 'Enter') {
                          e.preventDefault();
                          handleAddSubCategory();
                        }
                      }}
                    />
                    <button className="btn-add-skill" onClick={handleAddSubCategory}>
                      + Add SubCategory
                    </button>
                  </div>

                  {subCategories.length === 0 ? (
                    <p style={{ marginTop: '12px', color: '#666' }}>No subcategories yet. Add one above.</p>
                  ) : (
                    <div className="skills-manage-grid" style={{ marginTop: '12px' }}>
                      {subCategories.map((subCat) => {
                        const isEditing = editingSubCategoryId === subCat._id;
                        return (
                          <div key={subCat._id} className="skill-manage-card">
                            {isEditing ? (
                              <div style={{ width: '100%' }}>
                                <input
                                  type="text"
                                  value={editedSubCategoryName}
                                  onChange={(e) => setEditedSubCategoryName(e.target.value)}
                                  placeholder="Enter new subcategory name"
                                  style={{
                                    width: '100%',
                                    padding: '8px',
                                    marginBottom: '8px',
                                    borderRadius: '4px',
                                    border: '1px solid #ddd'
                                  }}
                                  onKeyPress={(e) => {
                                    if (e.key === 'Enter') {
                                      handleEditSubCategory(subCat._id);
                                    }
                                  }}
                                />
                                <div style={{ display: 'flex', gap: '8px' }}>
                                  <button
                                    onClick={() => handleEditSubCategory(subCat._id)}
                                    style={{
                                      flex: 1,
                                      padding: '6px 12px',
                                      backgroundColor: '#0052cc',
                                      color: 'white',
                                      border: 'none',
                                      borderRadius: '4px',
                                      cursor: 'pointer',
                                      fontSize: '12px'
                                    }}
                                  >
                                    Save
                                  </button>
                                  <button
                                    onClick={() => {
                                      setEditingSubCategoryId(null);
                                      setEditedSubCategoryName('');
                                    }}
                                    style={{
                                      flex: 1,
                                      padding: '6px 12px',
                                      backgroundColor: '#e0e6ed',
                                      color: '#333',
                                      border: 'none',
                                      borderRadius: '4px',
                                      cursor: 'pointer',
                                      fontSize: '12px'
                                    }}
                                  >
                                    Cancel
                                  </button>
                                </div>
                              </div>
                            ) : (
                              <>
                                <div className="skill-manage-info">
                                  <span className="skill-manage-label">{subCat.name}</span>
                                </div>
                                <div style={{ display: 'flex', gap: '8px' }}>
                                  <button
                                    onClick={() => {
                                      setSelectedSubCategoryId(subCat._id);
                                      fetchSpecifications(subCat._id);
                                    }}
                                    style={{
                                      flex: 1,
                                      padding: '6px 12px',
                                      backgroundColor: '#007bff',
                                      color: 'white',
                                      border: 'none',
                                      borderRadius: '4px',
                                      cursor: 'pointer',
                                      fontSize: '12px'
                                    }}
                                  >
                                    Manage Specs
                                  </button>
                                  <button
                                    className="btn-delete-skill"
                                    onClick={() => {
                                      setEditingSubCategoryId(subCat._id);
                                      setEditedSubCategoryName(subCat.name);
                                    }}
                                    title="Edit subcategory"
                                    style={{
                                      flex: 1,
                                      backgroundColor: '#ffa500',
                                      color: 'white'
                                    }}
                                  >
                                    <FaEdit /> Edit
                                  </button>
                                  <button
                                    className="btn-delete-skill"
                                    onClick={() => handleDeleteSubCategory(subCat._id)}
                                    title="Delete subcategory"
                                  >
                                    <FaTrash /> Delete
                                  </button>
                                </div>
                              </>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>

                {/* Specifications Section */}
                {selectedSubCategoryId && (
                  <div className="form-container">
                    <h3>Step 3: Manage Specifications for "{subCategories.find(s => s._id === selectedSubCategoryId)?.name}"</h3>
                    <div className="add-skill-inline">
                      <input
                        type="text"
                        value={newSpecificationName}
                        onChange={(e) => setNewSpecificationName(e.target.value)}
                        placeholder="Enter specification (e.g., CPU, RAM, Storage)"
                        onKeyPress={(e) => {
                          if (e.key === 'Enter') {
                            e.preventDefault();
                            handleAddSpecification();
                          }
                        }}
                      />
                      <button className="btn-add-skill" onClick={handleAddSpecification}>
                        + Add Specification
                      </button>
                    </div>

                    {specifications.length === 0 ? (
                      <p style={{ marginTop: '12px', color: '#666' }}>No specifications yet. Add one above.</p>
                    ) : (
                      <div className="skills-manage-grid" style={{ marginTop: '12px' }}>
                        {specifications.map((spec) => {
                          const isEditing = editingSpecificationId === spec._id;
                          return (
                            <div key={spec._id} className="skill-manage-card">
                              {isEditing ? (
                                <div style={{ width: '100%' }}>
                                  <input
                                    type="text"
                                    value={editedSpecificationName}
                                    onChange={(e) => setEditedSpecificationName(e.target.value)}
                                    placeholder="Enter new specification name"
                                    style={{
                                      width: '100%',
                                      padding: '8px',
                                      marginBottom: '8px',
                                      borderRadius: '4px',
                                      border: '1px solid #ddd'
                                    }}
                                    onKeyPress={(e) => {
                                      if (e.key === 'Enter') {
                                        handleEditSpecification(spec._id);
                                      }
                                    }}
                                  />
                                  <div style={{ display: 'flex', gap: '8px' }}>
                                    <button
                                      onClick={() => handleEditSpecification(spec._id)}
                                      style={{
                                        flex: 1,
                                        padding: '6px 12px',
                                        backgroundColor: '#0052cc',
                                        color: 'white',
                                        border: 'none',
                                        borderRadius: '4px',
                                        cursor: 'pointer',
                                        fontSize: '12px'
                                      }}
                                    >
                                      Save
                                    </button>
                                    <button
                                      onClick={() => {
                                        setEditingSpecificationId(null);
                                        setEditedSpecificationName('');
                                      }}
                                      style={{
                                        flex: 1,
                                        padding: '6px 12px',
                                        backgroundColor: '#e0e6ed',
                                        color: '#333',
                                        border: 'none',
                                        borderRadius: '4px',
                                        cursor: 'pointer',
                                        fontSize: '12px'
                                      }}
                                    >
                                      Cancel
                                    </button>
                                  </div>
                                </div>
                              ) : (
                                <>
                                  <div className="skill-manage-info">
                                    <span className="skill-manage-label">{spec.name}</span>
                                  </div>
                                  <div style={{ display: 'flex', gap: '8px' }}>
                                    <button
                                      className="btn-delete-skill"
                                      onClick={() => {
                                        setEditingSpecificationId(spec._id);
                                        setEditedSpecificationName(spec.name);
                                      }}
                                      title="Edit specification"
                                      style={{
                                        flex: 1,
                                        backgroundColor: '#ffa500',
                                        color: 'white'
                                      }}
                                    >
                                      <FaEdit /> Edit
                                    </button>
                                    <button
                                      className="btn-delete-skill"
                                      onClick={() => handleDeleteSpecification(spec._id)}
                                      title="Delete specification"
                                    >
                                      <FaTrash /> Delete
                                    </button>
                                  </div>
                                </>
                              )}
                            </div>
                          );
                        })}
                      </div>
                    )}
                  </div>
                )}
              </>
            )}
          </div>
        )}

        {/* Manage Skills Section */}
        {activeSection === 'manage-skills' && (
          <div className="section-content">
            <div className="section-header">
              <h1>Manage Asset Technician Skills</h1>
              <p>Add, view, or remove skills available across the system</p>
            </div>

            <div className="form-container" style={{ marginBottom: '24px' }}>
              <h3>Add New Skill</h3>
              <div className="add-skill-inline">
                <input
                  type="text"
                  value={newSkillName}
                  onChange={(e) => setNewSkillName(e.target.value)}
                  placeholder="Enter skill name (e.g., Networking)"
                  onKeyPress={(e) => {
                    if (e.key === 'Enter') {
                      e.preventDefault();
                      handleAddCustomSkill();
                    }
                  }}
                />
                <button className="btn-add-skill" onClick={handleAddCustomSkill}>
                  + Add Skill
                </button>
              </div>
            </div>

            {skillsOptions.length === 0 ? (
              <p>No skills found. Add your first skill above.</p>
            ) : (
              <div className="skills-manage-grid">
                {skillsOptions.map((skill) => {
                  const isEditing = editingSkillId === skill._id;
                  return (
                    <div key={skill._id} className="skill-manage-card">
                      {isEditing ? (
                        <div style={{ width: '100%' }}>
                          <input
                            type="text"
                            value={editedSkillName}
                            onChange={(e) => setEditedSkillName(e.target.value)}
                            placeholder="Enter new skill name"
                            style={{
                              width: '100%',
                              padding: '8px',
                              marginBottom: '8px',
                              borderRadius: '4px',
                              border: '1px solid #ddd'
                            }}
                            onKeyPress={(e) => {
                              if (e.key === 'Enter') {
                                handleEditSkill(skill._id);
                              }
                            }}
                          />
                          <div style={{ display: 'flex', gap: '8px' }}>
                            <button
                              onClick={() => handleEditSkill(skill._id)}
                              style={{
                                flex: 1,
                                padding: '6px 12px',
                                backgroundColor: '#0052cc',
                                color: 'white',
                                border: 'none',
                                borderRadius: '4px',
                                cursor: 'pointer',
                                fontSize: '12px'
                              }}
                            >
                              Save
                            </button>
                            <button
                              onClick={() => {
                                setEditingSkillId(null);
                                setEditedSkillName('');
                              }}
                              style={{
                                flex: 1,
                                padding: '6px 12px',
                                backgroundColor: '#e0e6ed',
                                color: '#333',
                                border: 'none',
                                borderRadius: '4px',
                                cursor: 'pointer',
                                fontSize: '12px'
                              }}
                            >
                              Cancel
                            </button>
                          </div>
                        </div>
                      ) : (
                        <>
                          <div className="skill-manage-info">
                            <span className="skill-manage-label">{skill.label}</span>
                            <span className="skill-manage-name">{skill.name}</span>
                          </div>
                          <div style={{ display: 'flex', gap: '8px' }}>
                            <button
                              className="btn-delete-skill"
                              onClick={() => {
                                setEditingSkillId(skill._id);
                                setEditedSkillName(skill.label);
                              }}
                              title="Edit skill"
                              style={{
                                flex: 1,
                                backgroundColor: '#ffa500',
                                color: 'white'
                              }}
                            >
                              <FaEdit /> Edit
                            </button>
                            <button
                              className="btn-delete-skill"
                              onClick={() => handleDeleteSkill(skill._id)}
                              title="Delete skill"
                            >
                              <FaTrash />
                            </button>
                          </div>
                        </>
                      )}
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        )}

        {/* Manage Categories Section */}
        {activeSection === 'manage-categories' && (
          <div className="section-content">
            <div className="section-header">
              <h1>Manage Asset Categories</h1>
              <p>Add or view asset categories used across the system</p>
            </div>

            <div className="form-container" style={{ marginBottom: '24px' }}>
              <h3>Add New Category</h3>
              <div className="add-skill-inline">
                <input
                  type="text"
                  value={newCategoryName}
                  onChange={(e) => setNewCategoryName(e.target.value)}
                  placeholder="Enter category name (e.g., Laptop, Projector)"
                  onKeyPress={(e) => {
                    if (e.key === 'Enter') {
                      e.preventDefault();
                      handleAddCategory();
                    }
                  }}
                />
                <button className="btn-add-skill" onClick={handleAddCategory}>
                  + Add Category
                </button>
              </div>
            </div>

            {categories.length === 0 ? (
              <p>No categories found. Add your first category above.</p>
            ) : (
              <div className="skills-manage-grid">
                {categories.map((cat) => {
                  const isEditing = editingCategoryId === cat._id;
                  return (
                    <div key={cat._id} className="skill-manage-card">
                      {isEditing ? (
                        <div style={{ width: '100%' }}>
                          <input
                            type="text"
                            value={editedCategoryName}
                            onChange={(e) => setEditedCategoryName(e.target.value)}
                            placeholder="Enter new category name"
                            style={{
                              width: '100%',
                              padding: '8px',
                              marginBottom: '8px',
                              borderRadius: '4px',
                              border: '1px solid #ddd'
                            }}
                            onKeyPress={(e) => {
                              if (e.key === 'Enter') {
                                handleEditCategory(cat._id);
                              }
                            }}
                          />
                          <div style={{ display: 'flex', gap: '8px' }}>
                            <button
                              onClick={() => handleEditCategory(cat._id)}
                              style={{
                                flex: 1,
                                padding: '6px 12px',
                                backgroundColor: '#0052cc',
                                color: 'white',
                                border: 'none',
                                borderRadius: '4px',
                                cursor: 'pointer',
                                fontSize: '12px'
                              }}
                            >
                              Save
                            </button>
                            <button
                              onClick={() => {
                                setEditingCategoryId(null);
                                setEditedCategoryName('');
                              }}
                              style={{
                                flex: 1,
                                padding: '6px 12px',
                                backgroundColor: '#e0e6ed',
                                color: '#333',
                                border: 'none',
                                borderRadius: '4px',
                                cursor: 'pointer',
                                fontSize: '12px'
                              }}
                            >
                              Cancel
                            </button>
                          </div>
                        </div>
                      ) : (
                        <>
                          <div className="skill-manage-info">
                            <span className="skill-manage-label">{cat.name}</span>
                          </div>
                          <div style={{ display: 'flex', gap: '8px' }}>
                            <button
                              className="btn-delete-skill"
                              onClick={() => {
                                setEditingCategoryId(cat._id);
                                setEditedCategoryName(cat.name);
                              }}
                              title="Edit category"
                              style={{
                                flex: 1,
                                backgroundColor: '#ffa500',
                                color: 'white'
                              }}
                            >
                              <FaEdit /> Edit
                            </button>
                            <button
                              className="btn-delete-skill"
                              onClick={() => handleDeleteCategory(cat._id)}
                              title="Delete category"
                            >
                              <FaTrash />
                            </button>
                          </div>
                        </>
                      )}
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        )}

        {/* Manage Departments Section */}
        {activeSection === 'manage-departments' && (
          <div className="section-content">
            <div className="section-header">
              <h1>Manage Departments</h1>
          
            </div>

            {/* Add New Department Form */}
            <div className="form-container" style={{ marginBottom: '16px' }}>
              <h3 style={{ marginBottom: '12px', fontSize: '14px' }}>Add New Department</h3>
              <div className="add-skill-inline">
                <input
                  type="text"
                  value={newDeptLabel}
                  onChange={(e) => setNewDeptLabel(e.target.value)}
                  placeholder="Enter department name (e.g., Marketing, Engineering)"
                  onKeyPress={(e) => {
                    if (e.key === 'Enter') {
                      e.preventDefault();
                      handleAddDepartment();
                    }
                  }}
                />
                <button className="btn-add-skill" onClick={handleAddDepartment}>
                  + Add Department
                </button>
              </div>
            </div>

            {/* Assign Department to Asset Incharge */}
            {approvedUsers.some(u => u.role === 'asset_incharge') && (
              <div style={{
                border: '1px solid #e0e6ed',
                borderRadius: '8px',
                padding: '14px 16px',
                marginBottom: '20px',
                backgroundColor: '#f8f9fc'
              }}>
                <h3 style={{ margin: '0 0 12px 0', color: '#0052cc', fontSize: '14px' }}>Assign Department to Asset Incharge</h3>
                <form onSubmit={handleAssignDepartment}>
                  <div className="form-row" style={{ gap: '12px' }}>
                    <div className="form-group">
                      <label style={{ fontSize: '12px' }}>Select Department *</label>
                      <select
                        value={assignDeptForm.departmentId}
                        onChange={(e) => setAssignDeptForm({
                          ...assignDeptForm,
                          departmentId: e.target.value
                        })}
                        required
                        style={{ fontSize: '13px', padding: '8px' }}
                      >
                        <option value="">Select a department</option>
                        {departments.map(dept => (
                          <option key={dept._id} value={dept.name}>{dept.label}</option>
                        ))}
                      </select>
                    </div>
                    <div className="form-group">
                      <label style={{ fontSize: '12px' }}>Select Asset Incharge *</label>
                      <select
                        value={assignDeptForm.assetInchargeId}
                        onChange={(e) => setAssignDeptForm({
                          ...assignDeptForm,
                          assetInchargeId: e.target.value
                        })}
                        required
                        style={{ fontSize: '13px', padding: '8px' }}
                      >
                        <option value="">Select an asset incharge</option>
                        {approvedUsers
                          .filter(user => user.role === 'asset_incharge')
                          .map(incharge => (
                            <option key={incharge._id} value={incharge._id}>
                              {incharge.name} ({incharge.email})
                            </option>
                          ))}
                      </select>
                    </div>
                  </div>
                  <button type="submit" className="btn-assign-dept">
                    <FaChartBar /> Assign
                  </button>
                </form>
              </div>
            )}

            {/* Departments List - Table Format */}
            {departments.length === 0 ? (
              <div className="no-data" style={{ marginTop: '12px' }}>
                <FaFolderPlus className="no-data-icon" />
                <p>No departments found. Add your first department above.</p>
              </div>
            ) : (
              <div style={{ marginTop: '12px' }}>
                <h3 style={{ marginBottom: '12px', fontSize: '16px', fontWeight: '700', color: '#1f2937' }}>Departments List</h3>
                <div className="users-table departments-table">
                  <table>
                    <thead>
                      <tr>
                        <th style={{ width: '22%' }}>Department Name</th>
                        <th style={{ width: '15%', textAlign: 'center' }}>Count</th>
                        <th style={{ width: '53%' }}>Incharge Details</th>
                        <th style={{ width: '10%', textAlign: 'center' }}>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {departments.map((dept) => {
                        const assignedIncharges = approvedUsers.filter(
                          u =>
                            u.role === 'asset_incharge' &&
                            (u.department === dept.name || u.department === dept.label)
                        );
                        const isEditing = editingDeptId === dept._id;

                        if (isEditing) {
                          return (
                            <tr key={dept._id}>
                              <td colSpan="4" style={{ padding: '14px' }}>
                                <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                                  <input
                                    type="text"
                                    value={editedDeptName}
                                    onChange={(e) => setEditedDeptName(e.target.value)}
                                    placeholder="Enter new department name"
                                    style={{
                                      flex: 1,
                                      padding: '8px 10px',
                                      borderRadius: '4px',
                                      border: '1px solid #ddd',
                                      fontSize: '16px'
                                    }}
                                    onKeyPress={(e) => {
                                      if (e.key === 'Enter') {
                                        handleEditDepartment(dept._id);
                                      }
                                    }}
                                  />
                                  <button
                                    onClick={() => handleEditDepartment(dept._id)}
                                    style={{
                                      padding: '6px 12px',
                                      backgroundColor: '#0052cc',
                                      color: 'white',
                                      border: 'none',
                                      borderRadius: '4px',
                                      cursor: 'pointer',
                                      fontSize: '16px',
                                      fontWeight: '600'
                                    }}
                                  >
                                    Save
                                  </button>
                                  <button
                                    onClick={() => {
                                      setEditingDeptId(null);
                                      setEditedDeptName('');
                                    }}
                                    style={{
                                      padding: '6px 12px',
                                      backgroundColor: '#e5e7eb',
                                      color: '#374151',
                                      border: 'none',
                                      borderRadius: '4px',
                                      cursor: 'pointer',
                                      fontSize: '12px',
                                      fontWeight: '600'
                                    }}
                                  >
                                    Cancel
                                  </button>
                                </div>
                              </td>
                            </tr>
                          );
                        }

                        return (
                          <tr key={dept._id}>
                            <td style={{ fontWeight: '600', color: '#1f2937', fontSize: '13px' }}>{dept.label}</td>
                            <td style={{ textAlign: 'center' }}>
                              <span style={{
                                display: 'inline-block',
                                padding: '3px 8px',
                                borderRadius: '10px',
                                fontSize: '12px',
                                fontWeight: '600',
                                backgroundColor: assignedIncharges.length > 0 ? '#dbeafe' : '#f3f4f6',
                                color: assignedIncharges.length > 0 ? '#0052cc' : '#6b7280',
                                minWidth: '24px',
                                textAlign: 'center'
                              }}>
                                {assignedIncharges.length}
                              </span>
                            </td>
                            <td style={{ padding: '6px 12px' }}>
                              {assignedIncharges.length > 0 ? (
                                <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                                  {assignedIncharges.map(incharge => (
                                    <div
                                      key={incharge._id}
                                      style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        padding: '5px 8px',
                                        backgroundColor: '#f9fafb',
                                        borderRadius: '4px',
                                        border: '1px solid #e5e7eb',
                                        fontSize: '12px'
                                      }}
                                    >
                                      <div style={{ display: 'flex', alignItems: 'center', gap: '6px', flex: 1, minWidth: 0 }}>
                                        {incharge.profilePic ? (
                                          <img
                                            src={incharge.profilePic}
                                            alt={incharge.name}
                                            style={{ width: '24px', height: '24px', borderRadius: '50%', objectFit: 'cover', flexShrink: 0 }}
                                          />
                                        ) : (
                                          <div style={{
                                            width: '24px',
                                            height: '24px',
                                            borderRadius: '50%',
                                            backgroundColor: '#e0f2ff',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            color: '#0052cc',
                                            flexShrink: 0
                                          }}>
                                            <FaUser size={10} />
                                          </div>
                                        )}
                                        <span style={{ color: '#1f2937', fontWeight: '500', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                          {incharge.name}
                                        </span>
                                      </div>
                                      <button
                                        onClick={() => handleUnassignDepartment(incharge._id)}
                                        title="Unassign from this department"
                                        style={{
                                          padding: '4px 8px',
                                          backgroundColor: '#fee2e2',
                                          color: '#dc2626',
                                          border: '1px solid #fecaca',
                                          borderRadius: '4px',
                                          cursor: 'pointer',
                                          fontSize: '11px',
                                          fontWeight: '600',
                                          transition: 'all 0.2s ease',
                                          minWidth: '60px',
                                          flexShrink: 0
                                        }}
                                        onMouseEnter={(e) => {
                                          e.target.style.backgroundColor = '#fca5a5';
                                          e.target.style.color = '#991b1b';
                                        }}
                                        onMouseLeave={(e) => {
                                          e.target.style.backgroundColor = '#fee2e2';
                                          e.target.style.color = '#dc2626';
                                        }}
                                      >
                                        Unassign
                                      </button>
                                    </div>
                                  ))}
                                </div>
                              ) : (
                                <span style={{ color: '#9ca3af', fontSize: '12px', fontStyle: 'italic' }}>No incharges assigned</span>
                              )}
                            </td>
                            <td style={{ textAlign: 'center', padding: '6px' }}>
                              <div style={{ display: 'flex', gap: '4px', justifyContent: 'center' }}>
                                <button
                                  onClick={() => {
                                    setEditingDeptId(dept._id);
                                    setEditedDeptName(dept.label);
                                  }}
                                  title="Edit department"
                                  style={{
                                    padding: '5px 8px',
                                    backgroundColor: '#fef3c7',
                                    color: '#92400e',
                                    border: '1px solid #fcd34d',
                                    borderRadius: '4px',
                                    cursor: 'pointer',
                                    fontSize: '11px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '3px'
                                  }}
                                >
                                  <FaEdit size={10} />
                                </button>
                                <button
                                  onClick={() => handleDeleteDepartment(dept._id)}
                                  title="Delete department"
                                  style={{
                                    padding: '5px 8px',
                                    backgroundColor: '#fee2e2',
                                    color: '#991b1b',
                                    border: '1px solid #fecaca',
                                    borderRadius: '4px',
                                    cursor: 'pointer',
                                    fontSize: '11px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '3px'
                                  }}
                                >
                                  <FaTrash size={10} />
                                </button>
                              </div>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            )}
          </div>
        )}

        {/* Asset User Requests Section */}

        {/* Admin Profile Section */}
        {activeSection === 'admin-profile' && (
          <AdminProfile />
        )}

        {activeSection === 'view-assets-inventory' && (
          <ViewAssets embedded showCreatedBy title="View Assets Inventory" />
        )}

        {/* View Plans Section */}
        {activeSection === 'view-plans' && (
          <AdminViewPlans />
        )}

        {/* Manage Invoices Section */}
        {activeSection === 'manage-invoices' && (
          <div className="section-content">
            <div className="section-header">
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                <div>
                  <h1>Manage Invoices</h1>
                  <p>Plan billing history, status, and downloadable invoices</p>
                </div>
                <button className="refresh-btn" onClick={fetchInvoices} disabled={invoicesLoading}>
                  <FaSync /> {invoicesLoading ? 'Loading...' : 'Refresh'}
                </button>
              </div>
            </div>

            <div className="users-table">
              <table>
                <thead>
                  <tr>
                    <th>Plan Name</th>
                    <th>Purchased On</th>
                    <th>Expiry/Next Billing</th>
                    <th>Status</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {invoicesLoading ? (
                    <tr>
                      <td colSpan="5" style={{ textAlign: 'center', padding: '20px' }}>Loading invoices...</td>
                    </tr>
                  ) : invoices.length === 0 ? (
                    <tr>
                      <td colSpan="5" style={{ textAlign: 'center', padding: '20px' }}>No invoices available yet</td>
                    </tr>
                  ) : (
                    invoices.map((invoice) => (
                      <tr key={invoice.id}>
                        <td>{invoice.planName || '-'}</td>
                        <td>{formatDate(invoice.purchasedOn)}</td>
                        <td>{formatDate(calculateDueDate(invoice.purchasedOn, invoice.billingCycle) || invoice.expiryDate)}</td>
                        <td>
                          <span className="role-badge" style={{ textTransform: 'capitalize' }}>
                            {invoice.status || 'ongoing'}
                          </span>
                        </td>
                        <td style={{ display: 'flex', gap: '8px' }}>
                          <button className="btn-sm" onClick={() => handleViewInvoice(invoice)} title="View Invoice">
                            <FaEye /> View
                          </button>
                          <button className="btn-sm" onClick={() => handleDownloadInvoice(invoice)} title="Download Invoice">
                            <FaDownload /> Download
                          </button>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {activeSection === 'download-data' && (
          <AdminDataDownload />
        )}
       
      </div>

      {/* Invoice Viewer Modal */}
      {viewingInvoice && ReactDOM.createPortal(
        <div className="modal" onClick={() => setViewingInvoice(null)} style={{ zIndex: 1000 }}>
          <div 
            className="modal-content" 
            onClick={(e) => e.stopPropagation()}
            style={{ 
              width: '95%', 
              maxWidth: '900px', 
              height: '90vh', 
              padding: '20px',
              display: 'flex',
              flexDirection: 'column'
            }}
          >
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' }}>
              <h2>Invoice Preview - {viewingInvoice.invoiceNumber || 'INV-000001'}</h2>
              <button 
                className="btn-secondary" 
                onClick={() => setViewingInvoice(null)}
                style={{ padding: '8px 16px', cursor: 'pointer' }}
              >
                ✕ Close
              </button>
            </div>
            {viewingInvoice.pdfDataUrl && (
              <iframe
                src={viewingInvoice.pdfDataUrl}
                style={{
                  flex: 1,
                  border: 'none',
                  borderRadius: '4px',
                  backgroundColor: '#f5f5f5'
                }}
                title="Invoice Preview"
              />
            )}
            <div style={{ marginTop: '15px', display: 'flex', gap: '10px' }}>
              <button 
                className="btn-primary" 
                onClick={() => {
                  handleDownloadInvoice(viewingInvoice);
                  setViewingInvoice(null);
                }}
              >
                <FaDownload /> Download Invoice
              </button>
              <button 
                className="btn-secondary" 
                onClick={() => setViewingInvoice(null)}
              >
                Close
              </button>
            </div>
          </div>
        </div>,
        document.body
      )}

      {planLimitPopup.visible && ReactDOM.createPortal(
        <div className="plan-limit-popup-overlay" onClick={closePlanLimitPopup}>
          <div className="plan-limit-popup-card" onClick={(e) => e.stopPropagation()}>
            <div className="plan-limit-popup-header">
              <h3>{planLimitPopup.title || 'Plan Action Required'}</h3>
              <p>{planLimitPopup.message || 'Your current plan limit is reached. Please renew or upgrade.'}</p>
            </div>

            <div className="popup-plan-list-wrap">
              <div className="popup-plan-list-title">Suggested Plans</div>

              {popupPlansLoading ? (
                <div className="popup-plan-empty">Loading plans...</div>
              ) : popupPlans.length === 0 ? (
                <div className="popup-plan-empty">No alternate plans found right now.</div>
              ) : (
                <div className="popup-plan-grid">
                  {popupPlans.slice(0, 3).map((plan) => (
                    <div className="popup-plan-card" key={plan._id || plan.name}>
                      <div className="popup-plan-name">{plan.name}</div>
                      <div className="popup-plan-price">₹{Number(plan.price || 0).toLocaleString()}/month</div>
                      <div className="popup-plan-meta">
                        <span>Users: {plan.users === 999 ? 'Unlimited' : Number(plan.users || 0)}</span>
                        <span>Assets: {plan.assets === 999 ? 'Unlimited' : Number(plan.assets || 0)}</span>
                      </div>
                      {Array.isArray(plan.features) && plan.features.length > 0 && (
                        <div className="popup-plan-feature">{plan.features.slice(0, 2).join(' • ')}</div>
                      )}
                    </div>
                  ))}
                </div>
              )}
            </div>

            <div className="plan-limit-popup-actions">
              <button
                type="button"
                className="plan-limit-btn primary"
                onClick={() => {
                  setActiveSection('view-plans');
                  closePlanLimitPopup();
                }}
              >
                Renew / Upgrade Plan
              </button>
              <button
                type="button"
                className="plan-limit-btn secondary"
                onClick={closePlanLimitPopup}
              >
                Close
              </button>
            </div>
          </div>
        </div>,
        document.body
      )}
    </div>
  );
};

export default LabAdminDashboard;